var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("e-sidebar", {
    attrs: {
      id: "sidebar-motoboy-presence",
      title: _vm.$t("Presença de Motoboys"),
      show: _vm.show,
      "hide-save-button": true,
      "cancel-button-text": _vm.$t("Fechar"),
      "no-close-on-backdrop": false,
      width: "30%",
    },
    on: {
      hidden: function ($event) {
        return _vm.$emit("hidden")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("FormulateInput", {
              attrs: {
                id: "motoboy-presence-sidebar_filter",
                type: "text",
                label: _vm.$t("Nome"),
                placeholder: _vm.$t("Filtrar por nome"),
              },
              model: {
                value: _vm.nameFilter,
                callback: function ($$v) {
                  _vm.nameFilter = $$v
                },
                expression: "nameFilter",
              },
            }),
            _c(
              "b-alert",
              {
                staticClass: "mb-0",
                attrs: { show: !_vm.filteredMotoboys.length, variant: "light" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.motoboys.length
                        ? _vm.$t(
                            "Nenhum Motoboy encontrado para o filtro informado"
                          )
                        : _vm.$t("Não há Motoboys vinculados a esta loja")
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "ul",
              { staticClass: "motoboy-presence-list list-unstyled mb-0" },
              _vm._l(_vm.filteredMotoboys, function (motoboy) {
                return _c(
                  "li",
                  {
                    key: _vm.motoboyId(motoboy),
                    staticClass:
                      "motoboy-presence-list__item d-flex align-items-center justify-content-between",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.motoboyName(motoboy))),
                        ]),
                        _c(
                          "b-badge",
                          {
                            staticClass: "ml-50",
                            attrs: { variant: _vm.presenceVariant(motoboy) },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.presenceLabel(motoboy)) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm.presenceState(motoboy) === "Absent"
                      ? _c("e-button", {
                          attrs: {
                            id:
                              "motoboy-presence-sidebar_present-" +
                              _vm.motoboyId(motoboy),
                            size: "sm",
                            icon: "person-check",
                            busy: _vm.isPending(motoboy),
                            text: _vm.$t("Marcar presente"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changePresence(motoboy, "Present")
                            },
                          },
                        })
                      : _vm.presenceState(motoboy) === "Present"
                      ? _c("e-button", {
                          attrs: {
                            id:
                              "motoboy-presence-sidebar_absent-" +
                              _vm.motoboyId(motoboy),
                            size: "sm",
                            variant: "outline-secondary",
                            icon: "person-x",
                            busy: _vm.isPending(motoboy),
                            text: _vm.$t("Marcar ausente"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changePresence(motoboy, "Absent")
                            },
                          },
                        })
                      : !_vm.hasDeliveryInRoute(motoboy)
                      ? _c("e-button", {
                          attrs: {
                            id:
                              "motoboy-presence-sidebar_release-" +
                              _vm.motoboyId(motoboy),
                            size: "sm",
                            icon: "person-check",
                            busy: _vm.isPending(motoboy),
                            text: _vm.$t("Liberar"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changePresence(motoboy, "Present")
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
              0
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }